import axios from "./axios-auth";

const excelReport = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getcreditorderreport",
      data: payload,
      method: "POST",
      responseType: "blob",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("error while posting excel report data" + err);
      });
  });

export { excelReport };
